import React from 'react';
import { FiX, FiMessageSquare, FiPlus, FiTrash2, FiMoon, FiSun, FiUsers, FiUser } from 'react-icons/fi';
import { useApp } from '../../context/AppContext';
import { playDeleteSound } from '../../utils/notificationSound';
import { useNdTheme } from '../../utils/ndTheme';
import '../../styles/newDesign.css';

export default function ChatsListModal() {
  const { state, dispatch } = useApp();
  const { isLight: ndIsLight, toggle: toggleNdTheme } = useNdTheme();
  const chats = state.chats || [];
  const currentChatId = state.currentChat?.id;
  const [deletingChats, setDeletingChats] = React.useState(new Set());

  const close = () => dispatch({ type: 'TOGGLE_MODAL', payload: { modal: 'chatsList', show: false } });

  // Обработчики событий удаления чата
  React.useEffect(() => {
    if (!window.socket) return;

    const handleDeleteError = (error) => {
      console.error('Ошибка удаления чата:', error);
      alert('Не удалось удалить чат. Попробуйте еще раз.');
      setDeletingChats(new Set());
    };

    const handleChatDeleted = (data) => {
      setDeletingChats(prev => {
        const newSet = new Set(prev);
        newSet.delete(data.chatId);
        return newSet;
      });

      dispatch({ type: 'DELETE_CHAT', payload: { chatId: data.chatId } });

      if (state.currentChat?.id === data.chatId) {
        dispatch({ type: 'SET_CURRENT_CHAT', payload: null });
      }

      if (window.socket) {
        window.socket.emit('get_chats');
      }
    };

    window.socket.on('chat_delete_error', handleDeleteError);
    window.socket.on('chat_deleted', handleChatDeleted);

    return () => {
      window.socket.off('chat_delete_error', handleDeleteError);
      window.socket.off('chat_deleted', handleChatDeleted);
    };
  }, [dispatch, state.currentChat?.id]);

  const handleSelect = (chat) => {
    dispatch({ type: 'SET_CURRENT_CHAT', payload: chat });
    close();
  };

  const handleCreateChat = () => {
    dispatch({ type: 'TOGGLE_MODAL', payload: { modal: 'createChat', show: true } });
  };

  const handleDeleteChat = (chatId, chatName, event) => {
    event.stopPropagation();
    if (!window.confirm(`Вы уверены, что хотите удалить чат "${chatName}"?`)) return;

    playDeleteSound(0.3);
    setDeletingChats(prev => new Set([...prev, chatId]));

    if (window.socket) {
      window.socket.emit('delete_chat', { chatId });
    } else {
      alert('Нет соединения с сервером');
      setDeletingChats(prev => {
        const newSet = new Set(prev);
        newSet.delete(chatId);
        return newSet;
      });
      return;
    }

    // Страховка, если сервер не ответит
    setTimeout(() => {
      setDeletingChats(prev => {
        const newSet = new Set(prev);
        newSet.delete(chatId);
        return newSet;
      });
    }, 5000);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100001,
        background: 'rgba(4,10,13,0.72)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
      onClick={close}
    >
      <div className="nd-chatsSide" onClick={e => e.stopPropagation()}>
        <div className="nd-empHead">
          <span className="nd-hIco"><FiMessageSquare /></span>
          <h2>Ваши чаты</h2>
          <button
            type="button"
            className="nd-themeBtn"
            style={{ marginLeft: 'auto' }}
            onClick={toggleNdTheme}
            title={ndIsLight ? 'Включить тёмную тему' : 'Включить светлую тему'}
          >
            {ndIsLight ? <FiMoon /> : <FiSun />}
          </button>
          <button type="button" className="nd-empClose" onClick={close} aria-label="Закрыть" title="Закрыть">
            <FiX />
          </button>
        </div>

        <div className="nd-empBody">
          <div className="nd-chipRow">
            <button type="button" className="nd-fChip create" onClick={handleCreateChat} title="Создать чат">
              <FiPlus size={13} /> Создать чат
            </button>
          </div>

          <div className="nd-chatsList">
            {chats.length === 0 ? (
              <div className="nd-empEmpty">Нет чатов</div>
            ) : (
              chats.map((chat, i) => {
                const isGroup = chat.type === 'group' || chat.isGroup;
                const active = currentChatId === chat.id;
                const deleting = deletingChats.has(chat.id);

                return (
                  <div
                    key={chat.id}
                    className={`nd-chatRow${active ? ' nd-active' : ''}`}
                    style={{ animationDelay: `${Math.min(i * 50, 400)}ms`, opacity: deleting ? 0.55 : undefined }}
                    onClick={() => handleSelect(chat)}
                  >
                    <span className="nd-ci">{isGroup ? <FiUsers /> : <FiUser />}</span>
                    <span className="nd-chName">{chat.name || 'Приватный чат'}</span>
                    {Number(chat.unread_count) > 0 && (
                      <span className="nd-chBadge">{chat.unread_count}</span>
                    )}
                    <span className="nd-chTime">
                      {chat.last_message_time
                        ? new Date(chat.last_message_time).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
                        : ''}
                    </span>
                    <button
                      type="button"
                      className="nd-del"
                      title="Удалить чат"
                      disabled={deleting}
                      onClick={e => handleDeleteChat(chat.id, chat.name || 'Приватный чат', e)}
                    >
                      {deleting ? <span className="nd-chSpin" /> : <FiTrash2 />}
                    </button>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
